/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../../constant';
import * as actions from '../../action';

function AddModalFees({
  data,
  createCalculationZoningFees,
  updating,

  id,
  history,
  ordinanceRevisionId,
  getSingleNewOtherFees,
  getNewOtherFeesList,
  // newOtherFeesInfo,
}) {
  const [formData, setFormData] = useState(() => {
      return {
        zoning_application_fee: '',
        zoning_base_line: '',
        zoning_processing_fee_percentage: '',
        bpls_other_fee_id: '',
      }
  });

  const validateForm = useFormValidator(formData, {
    zoning_application_fee: 'required',
    zoning_base_line: 'required',
    zoning_processing_fee_percentage: 'required',
  });

  const setModal = useContext(ModalContext);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      zoning_application_fee: _.get(formData, 'zoning_application_fee'),
      zoning_base_line: _.get(formData, 'zoning_base_line'),
      zoning_processing_fee_percentage: _.get(formData, 'zoning_processing_fee_percentage'),
    };

    // todo: add zoningID
    createCalculationZoningFees(id, args, () => {
      setModal({ isOpen: false });
      getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
      history.push(`/bpls/tax-revenue/new-other-fees/${id}`);
      getSingleNewOtherFees(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Zoning Application Fee: {validateForm.renderMessage('zoning_application_fee')}
            </label>
            <input
              className="form-control"
              type="text"
              name="zoning_application_fee"
              onChange={onChange}
              placeholder=""
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'zoning_application_fee')}
              // disabled
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Zoning Processing Fee: {validateForm.renderMessage('zoning_base_line')}
            </label>  
            <input
              className="form-control"
              type="text"
              name="zoning_base_line"
              onChange={onChange}
              placeholder=""
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'zoning_base_line')}
              // disabled
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Zoning Fee: {validateForm.renderMessage('zoning_processing_fee_percentage')}
            </label> 
            <input
              className="form-control"
              type="text"
              name="zoning_processing_fee_percentage"
              onChange={onChange}
              placeholder=""
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'zoning_processing_fee_percentage')}
              // disabled
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AddModalFees.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  createCalculationZoningFees: PropTypes.instanceOf(Function).isRequired,
  // newOtherFeesInfo: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_CALCULATION_ZONING_FEES) > -1,
  // newOtherFeesInfo: _.get(api, `${c.GET_SINGLE_NEW_OTHER_FEES}.item`) || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddModalFees);
